import React, { useState } from 'react'
import './styles.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCheck } from '@fortawesome/free-solid-svg-icons';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import ModalAction from '../../ModalAction';

interface Props {
  step: number;
  stepLabels: string[];
  onTabClick?: (index: number) => void;
  skipConfirmation?: boolean;
}

function DefaultTabs({ step, stepLabels, onTabClick, skipConfirmation }: Props) {

  const accessibility = useAccessibility()
  const font14Style = accessibility.calculateTextStyle(14)
  const contrastMode = accessibility.contrastMode
  const contrastColor = accessibility.contrastColor

  const [modalAction, setModalAction] = useState<null | {
    handleShowModal?: () => void; textOutlinedButton: string; textContainedButton: string; title: string; subTitle?: string;
    handleOutlinedButton?: () => void; handleContainedButton?: () => void; icon?: "error" | "success" | "warning"
  }>(null);


  const goToStep = (index: number) => {
    if (!onTabClick) return;
    if (!skipConfirmation) {
      openModalAction('Atenção!', 'Ao retornar para a página solicitada, os dados preenchidos serão desconsiderados. Deseja continuar?', 'Não', 'Sim', 
        () => { closeModalAction() },
        () => { setModalAction(null); onTabClick(index); });
    } else  {
      onTabClick(index);
    }
  }

  const openModalAction = (
    title: string, subTitle: string, textOutlinedButton: string, textContainedButton: string,
    handleOutlinedButton?: () => void, handleContainedButton?: () => void, icon?: "error" | "success" | "warning"
  ) => {
    setModalAction({
      title: title,
      subTitle: subTitle,
      textOutlinedButton: textOutlinedButton,
      textContainedButton: textContainedButton,
      handleContainedButton: handleContainedButton,
      handleOutlinedButton: handleOutlinedButton,
      handleShowModal: closeModalAction,
      icon: icon || 'warning'
    })
  }

  const closeModalAction = () => {
    setModalAction(null);
  }


  const tabWidth = `${(100 / stepLabels.length) * (step + 1)}%`;

  const getIcon = (index: number) => {
    if (step < index) {
      return (
        <div 
          className='default-tab-icon-holder'
          style={contrastMode ? {borderColor: 'white'} : {} }
        >
          <span
            style={{ color: contrastMode ? 'white' : 'var(--grey-dark-medium, #5F5F5F)'}}>
            {index + 1}
          </span>
        </div>
      )
    }
    if (step === index) {
      return (
        <div 
          className='default-tab-icon-holder'
          style={contrastMode ? {borderColor: contrastColor} : {} }
        >
          <span
            style={{ color: contrastMode ? contrastColor : '#00995D'}}>
            {index + 1}
          </span>
        </div>
      )
    }
    else {
      return (
        <div 
          className="default-tab-icon-holder"
          style={contrastMode ? {borderColor: contrastColor} : {} }
        >
          <div className="check-icon">
            <FontAwesomeIcon style={accessibility.contrastColorAccessibility} icon={faCheck} size='xs'/>
          </div>
        </div>
      )
    }
  }

  const isClickable = (index: number) => {
    return index < step && onTabClick;
  }

  return (
    <div className='default-tabs-holder'>
      <div className="default-slider">
        <div 
          style={{ background: accessibility.contrastMode ? accessibility.contrastColor : '', width: tabWidth }} className={`default-progress`}/>
      </div>
      <div className="default-tabs">
      {
        stepLabels.map((label, index) => (
            <div 
              key={index} 
              className={`default-tab ${isClickable(index) && 'clickable-tab'}`}
              onClick={isClickable(index) ? () => goToStep(index) : () => {}}
              onKeyDown={e => { if (e.key === "Enter" && isClickable(index)) { goToStep(index) }}}
              tabIndex={isClickable(index)  ? 0 : -1}
            >
              {getIcon(index)}
              <span style={font14Style}>{label}</span>
            </div>
        ))
      }
      </div>
      <ModalAction
        showModal={!!modalAction}
        handleShowModal={modalAction?.handleShowModal}
        icon={modalAction?.icon}
        textOutlinedButton={modalAction?.textOutlinedButton || ''}
        textContainedButton={modalAction?.textContainedButton || ''}
        title={modalAction?.title || ''}
        subTitle={modalAction?.subTitle || ''}
        handleOutlinedButton={modalAction?.handleOutlinedButton}
        handleContainedButton={modalAction?.handleContainedButton}
      />
    </div>
  )
}

export default DefaultTabs